import * as S from './IhPanWarningTY.styles';

interface IhPanWarningTYProps {
  panWarning: string;
  isMweb?: boolean;
}

const IhPanWarningTY: React.FC<IhPanWarningTYProps> = ({panWarning, isMweb}) => {
  return (
    <S.AdditionalChargesWrapperDiv isMweb={isMweb}>
      <S.PanWarningText>{panWarning}</S.PanWarningText>
    </S.AdditionalChargesWrapperDiv>
  );
};

export default IhPanWarningTY;
